// import APIModel from '~/scripts/services/model/api';
import semver from 'semver';

export default class AgentCtrl {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} Agent
	 * @param {any} $scope
	 * @param {angular.ui.bootstrap.IModalInstanceService} $uibModalInstance
	 */
	constructor(
		Agent,
		$rootScope,
		$scope,
		$uibModalInstance,
	) {
		/** @type {angular.ui.bootstrap.IModalInstanceService} */
		this.$uibModalInstance = $uibModalInstance;
		// Keep Agent so it's loaded at start
		this.Agent = Agent;
		this.$scope = $scope;
		this.$rootScope = $rootScope;
		this.color = 'grey';
		this.spin = false;
		this.urls = {
			windows: {
				zip: '',
				exe: '',
			},
			mac: {
				zip: '',
			},
			linux: {
				zip: '',
				exe: '',
			},
		};
		this.text = 'Déconnecté';
		this.extra = '';

		this.token = 'fKzfxqzs4MAGd2WzE3kD';
		this.URLtoken = `?private_token=${this.token}`;

		this.latestRelease = {};
	}

	// eslint-disable-next-line class-methods-use-this
	async fetchRelease() {
		this.$scope.$evalAsync(async () => {
			const response = await fetch('https://git.knitiv.net/api/v4/projects/39/releases', {
				method: 'GET',
				headers: {
					'PRIVATE-TOKEN': this.token, // api_read sur projet agent uniquement
				},
			});

			const data = await response.json();

			const latest = data
				.map(release => release.tag_name)
				.sort((a, b) => semver.rcompare(a, b))[0];

			this.latestRelease = data.find(release => release.tag_name === latest);

			const { links } = this.latestRelease.assets;
			this.urls.windows.zip = links.find(
				asset => asset.name.includes('win') && asset.name.includes('zip'),
			)?.url + this.URLtoken;
			this.urls.windows.exe = links.find(
				asset => asset.name.includes('win') && asset.name.includes('exe'),
			)?.url + this.URLtoken;
			this.urls.linux.zip = links.find(
				asset => asset.name.includes('lin') && asset.name.includes('zip'),
			)?.url + this.URLtoken;
			this.urls.linux.exe = links.find(
				asset => asset.name.includes('lin') && asset.name.includes('AppImage'),
			)?.url + this.URLtoken;
			this.urls.mac.zip = links.find(
				asset => asset.name.includes('mac') && asset.name.includes('zip'),
			)?.url + this.URLtoken;
		});
	}

	close() {
		this.$uibModalInstance.close();
	}

	async onClick() {
		const actions = {
			connected: () => {
				//
			},
			denied: () => {
				this.Agent.connect();
			},
			error: () => {
				this.Agent.connect();
			},
			disconnected: () => {
				this.Agent.connect();
			},
		};

		this.$scope.$evalAsync(async () => {
			await actions[this.Agent.status]();
		});
	}

	// eslint-disable-next-line class-methods-use-this
	$onInit() {
		this.$rootScope.$on('agent:connected', () => {
			this.$scope.$evalAsync(() => {
			// console.log('connected');
				this.color = 'green';
				this.spin = false;
				this.text = 'Connecté';
				this.extra = 'Connecté';
				this.Agent.status = 'connected';
			});
		});

		this.$rootScope.$on('agent:denied', () => {
			this.$scope.$evalAsync(() => {
			// console.log('denied');
				this.color = 'orange';
				this.spin = false;
				this.text = 'Acces refusé';
				this.extra = 'L\'acces a l\'agent a été refusé par l\'agent';
				this.Agent.status = 'denied';
			});
		});

		this.$rootScope.$on('agent:error', () => {
			this.$scope.$evalAsync(() => {
			// console.log('error');
				this.color = 'red';
				this.spin = true;
				this.text = 'Erreur';
				this.extra = 'Une erreur est survenue lors de la connexion';
				this.Agent.status = 'error';
			});
		});

		this.$rootScope.$on('agent:disconnected', () => {
			this.$scope.$evalAsync(() => {
			// console.log('disconnected');
				this.color = 'orange';
				this.spin = true;
				this.text = 'Déconnecté';
				this.extra = 'L\'agent n\'est pas connecté';
				this.Agent.status = 'disconnected';
			});
		});

		this.fetchRelease();
	}
}
